const slugify = (source) =>
	source.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");

exports.slugify = slugify;